import { WebRoutes } from "consts/enpoints/web";
import { Step } from "ui/organizms/ECommerce/Onboarding/common";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingApplication } from "../../hooks";
import { useDirectorsAndShareholders } from "./useDirectorsAndShareholders";

const DirectorsAndShareholders = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const directorsAndShareholders = useDirectorsAndShareholders();

    return (
        <Step
            title='Directors and Shareholders'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.HighRiskMerchant}
        >
            <HighRiskMerchant.DirectorsAndShareholders.Form
                {...directorsAndShareholders}
            />
        </Step>
    );
};

export default DirectorsAndShareholders;
// export default withApplication(DirectorsAndShareholders);
